import { useNavigate } from "react-router-dom";
import { Box, Tab, Tabs } from "@mui/material";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import React from "react";
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}
const dauData = [
    { name: "Mon", users: 600 },
    { name: "Tue", users: 820 },
    { name: "Wed", users: 760 },
    { name: "Thu", users: 900 },
    { name: "Fri", users: 670 },
    { name: "Sat", users: 1020 },
    { name: "Sun", users: 890 },
];

const ViewBlogs = () => {
    const navigate = useNavigate();

    const [valueTabs, setValueTabs] = React.useState(0);
    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValueTabs(newValue);
    };
    const blog = {
        id: "#ART-001",
        title: "How to Style Your Winter Jacket",
        cover: "/static/images/placeholder.png",
        category: "Styling Tips",
        excerpt: "Learn how to match winter jackets with everyday outfits.",
        content: "<p>This is rich text content...</p>",
        relatedProducts: ["Winter Jacket", "Leather Boots"],
        status: "Published",
        publishDate: "2025-01-12",
        tags: "winter, styling, jackets",
        seoTitle: "Best Winter Jacket Styling Tips",
        seoDesc: "Learn the top styling tricks for winter jackets.",
        language: "English",
    };

    return (
        <>
            <div className="main_title">
                <h1>View Journal</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
                    <button onClick={() => navigate("/blogs")}>Manage Journals</button> -
                    View Journal
                </p>
            </div>
            <Box className="custom_tabs1" sx={{ width: "100%" }}>
                <Tabs
                    value={valueTabs}
                    onChange={handleChangeTabs}
                    aria-label="basic tabs example"
                    className="custom_tabs_links tabs_img"
                >
                    <Tab label="Basic Information" {...a11yProps(0)} />
                    <Tab
                       
                        label="Analytics insights"
                        {...a11yProps(1)}
                    />{" "}
                </Tabs>
            </Box>
            <div className="cards custom_form_details">
                <CustomTabPanel value={valueTabs} index={0}>
                    <div className="form view_mode">
                        <div className="gap_m">

                            {/* Article Title */}
                            <div className="control_group w_100">
                                <label>Article Title</label>
                                <p className="view_value">{blog.title}</p>
                            </div>

                            {/* Cover Image */}
                            <div className="control_group w_100 vew_img no_radius">
                                <label>Cover Image</label>
                                <figure>
                                    <img
                                        src={blog.cover}
                                        alt="cover"
                                        className="view_image"
                                    />
                                </figure>
                            </div>

                            {/* Category */}
                            <div className="control_group w_50">
                                <label>Category</label>
                                <p className="view_value">{blog.category}</p>
                            </div>

                            {/* Excerpt */}
                            <div className="control_group w_50">
                                <label>Short Summary / Excerpt</label>
                                <p className="view_value">{blog.excerpt}</p>
                            </div>

                            {/* Description */}
                            <div className="control_group w_100">
                                <label>Description</label>
                                <div
                                    className="view_richtext"
                                    dangerouslySetInnerHTML={{ __html: blog.content }}
                                />
                            </div>

                            {/* Related Products */}
                            <div className="control_group w_100">
                                <label>Related Products</label>
                                <p className="view_value">
                                    {blog.relatedProducts.join(", ")}
                                </p>
                            </div>

                            {/* Status */}
                            <div className="control_group w_50">
                                <label>Status</label>
                                <p className="view_value">{blog.status}</p>
                            </div>

                            {/* Publish Date */}
                            <div className="control_group w_50">
                                <label>Published On</label>
                                <p className="view_value">{blog.publishDate}</p>
                            </div>

                            {/* Tags */}
                            <div className="control_group w_50">
                                <label>Tags / Keywords</label>
                                <p className="view_value">{blog.tags}</p>
                            </div>

                            {/* SEO Title */}
                            <div className="control_group w_50">
                                <label>SEO Title</label>
                                <p className="view_value">{blog.seoTitle}</p>
                            </div>

                            {/* SEO Description */}
                            <div className="control_group w_100">
                                <label>SEO Description</label>
                                <p className="view_value">{blog.seoDesc}</p>
                            </div>

                            {/* Language */}
                            <div className="control_group w_50">
                                <label>Language</label>
                                <p className="view_value">{blog.language}</p>
                            </div>

                        </div>
                    </div>
                </CustomTabPanel>
                <CustomTabPanel value={valueTabs} index={1}>
                    <div className="campaign-dashboard">
                        {/* ===== Stats Row ===== */}
                        <div className="campaign-stats">
                            <div className="stat-card">
                                <span className="stat-label">Impressions</span>
                                <span className="stat-value">12,540</span>
                                <span className="stat-sub">Total Views</span>
                            </div>

                            <div className="stat-card">
                                <span className="stat-label">Clicks</span>
                                <span className="stat-value">1,820</span>
                                <span className="stat-sub">Engagement Count</span>
                            </div>

                            <div className="stat-card">
                                <span className="stat-label">Conversions</span>
                                <span className="stat-value">134</span>
                                <span className="stat-sub success">+7.3% Rate</span>
                            </div>

                            <div className="stat-card">
                                <span className="stat-label">ROI</span>
                                <span className="stat-value">4.8×</span>
                                <span className="stat-sub info">Return Ratio</span>
                            </div>
                        </div>

                        {/* ===== Row of Performance and Products ===== */}
                        <div className="section-row">
                            {/* ==== Left: Performance Over Time ==== */}
                            <div className="card-large table_container">
                                <h3>Performance Over Time</h3>

                                {/* Table */}
                                <table className="table_container">
                                    <thead>
                                        <tr>
                                            <th>Campaign Name</th>
                                            <th>Impressions</th>
                                            <th>Clicks</th>
                                            <th>Conversions</th>
                                            <th>ROI</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr>
                                            <td>Campaign A</td>
                                            <td>12,540</td>
                                            <td>1,820</td>
                                            <td>134</td>
                                            <td>4.8×</td>
                                        </tr>

                                        <tr>
                                            <td>Campaign B</td>
                                            <td>16,320</td>
                                            <td>1,630</td>
                                            <td>72</td>
                                            <td>4.8×</td>
                                        </tr>
                                    </tbody>
                                </table>

                                {/* Chart */}
                                <div className="chart-wrapper">
                                    <ResponsiveContainer width="100%" height={250}>
                                        <BarChart data={dauData}>
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="name" />
                                            <YAxis />
                                            <Tooltip />
                                            <Bar
                                                dataKey="users"
                                                fill="#D3B88C"
                                                radius={[6, 6, 0, 0]}
                                            />
                                        </BarChart>
                                    </ResponsiveContainer>
                                </div>
                            </div>

                            {/* ==== Right: Top Product Influenced ==== */}
                            <div className="card-small table_container">
                                <h3>Top Products Influenced</h3>

                                <table>
                                    <thead>
                                        <tr>
                                            <th>Product</th>
                                            <th>Impressions</th>
                                            <th>Clicks</th>
                                            <th>Conv.</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr>
                                            <td>Product A</td>
                                            <td>133</td>
                                            <td>134</td>
                                            <td>7.3%</td>
                                        </tr>
                                        <tr>
                                            <td>Product B</td>
                                            <td>98</td>
                                            <td>102</td>
                                            <td>5.2%</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <ul className="insights">
                                    <li>Clicks improved by 12% this week</li>
                                    <li>ROI is above category average</li>
                                    <li>More customers engaged in evenings</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </CustomTabPanel>
            </div>
        </>
    );
};

export default ViewBlogs;
